module.exports = __webpack_public_path__ + "img/sample-logo.00f50e8f.svg";